import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { CountryManagementService } from 'src/service/country-management.service';
import { CommunicationGateway, CommunicationTemplateReq, GeneralConfigType, InteractionType, KeyValueSet, KeyValues3, LocalService, NotificationType, Status, Wrapper5 } from 'src/service/local.service';

@Component({
  selector: 'app-template-ids',
  templateUrl: './template-ids.component.html',
  styleUrls: ['./template-ids.component.scss']
})
export class TemplateIdsComponent implements OnInit {
  ctryId = ''; selectedNotificationType: string = '1'; selectedCommunicationGatewayType: string = '2';
  communicationTemplateType: number; communicationTemplateReq: CommunicationTemplateReq; generalConfigType: GeneralConfigType = GeneralConfigType.None; maxBodyHeight = 0; content: Wrapper5; contentId = '';
  notificationTypes: KeyValueSet[] = []; communicationGatewayTypes: KeyValueSet[] = [];
  ctryCode: string = ''; userId = ''; interactionType: InteractionType = InteractionType.None;
  items: KeyValues3[] = [];

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private countryManagementService: CountryManagementService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      if (this.interactionType == InteractionType.Bill_PnixSoft) {
        this.communicationTemplateType = parseInt(routeParams.communicationTemplateType);
        this.generalConfigType = parseInt(routeParams.configCode);
        this.contentId = routeParams.contentId;
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
        this.userId = routeParams.userId;
        this.ctryCode = routeParams.ctryCode;
        this.onInitiate();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.notificationTypes = Object.keys(NotificationType)
      .map(function (x) {
        return {
          key: x.toString(),
          value: NotificationType[parseInt(x)]
        } as KeyValueSet;
      });

    this.communicationGatewayTypes = Object.keys(CommunicationGateway)
      .map(function (x) {
        return {
          key: x.toString(),
          value: CommunicationGateway[parseInt(x)]
        } as KeyValueSet;
      });
    this.notificationTypes = this.notificationTypes.filter(x => parseInt(x.key) > 0 && x.value);
    this.communicationGatewayTypes = this.communicationGatewayTypes.filter(x => parseInt(x.key) > 0 && x.value);

    this.selectedNotificationType = this.getNotificationType().toString();

    this.configurationManagementService.getConfiguration(this.contentId).subscribe(result => {
      this.content = result;
    });

    if (!this.localService.countryCodes) {
      this.countryManagementService.getCountryCodesToDisplay().subscribe(result => {
        this.localService.countryCodes = result;
        this.onSetCountryId();
        this.onLoad();
      });
    } else {
      this.onSetCountryId();
      this.onLoad();
    }
  }

  onSetCountryId() {
    if (this.ctryId == '') {
      let defacultCountry = this.localService.countryCodes.find(x => x.v2 == this.localService.selected.countryCode);
      this.ctryId = defacultCountry ? defacultCountry.key : this.localService.getCurrentTimeZoneCountryId();
    }
  }

  onLoad() {
    this.communicationTemplateReq = {
      countryCode: this.localService.getCountryCodeByCountryId(this.ctryId),
      communicationGatewayType: parseInt(this.selectedCommunicationGatewayType),
      notificationType: parseInt(this.selectedNotificationType),
      communicationTemplateType: this.communicationTemplateType
    } as CommunicationTemplateReq;

    this.items = [];
    this.configurationManagementService.getCommunicationTemplateIds(this.communicationTemplateReq).subscribe(result => {
      this.localService.languages.forEach(language => {
        let item = result.find(x => x.v2 == language.key);
        this.items.push({
          key: item ? item.key : '',
          v1: item ? item.v1 : '',
          v2: language.key
        } as KeyValues3);
      });
    });
  }

  onSave() {
    this.configurationManagementService.saveCommunicationTemplateIds(this.communicationTemplateReq, this.items).subscribe(result => {
      this.localService.showInformationByStatus(Status.Success);
      this.onLoad();
    });
  }

  getContent(languageId: string): string {
    let rtn = '-';
    if (this.content) {
      let item = this.content.languageContents.find(x => x.v1 == languageId);
      rtn = item ? item.v3 : '-';
    }
    return rtn;
  }

  getNotificationType(): NotificationType {
    switch (this.generalConfigType) {
      case GeneralConfigType.CommunicationTemplateEmail: {
        return NotificationType.Email;
      }
      default: {
        return NotificationType.WhatsApp;
      }
    }
  }
}
